var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"concat"},[_vm._v(" 电话：400-107-8586 ")])])
}]

export { render, staticRenderFns }